import React from 'react';
import { Routes, Route } from 'react-router-dom';

const InitialProductOrder = React.lazy(() => import('pages/initial-product/InitialProductOrder'));

export const URL_INITIAL_PRODUCT = '/initial-product';
export const URL_INITIAL_PRODUCT_ORDER = '/order'; // 교재 주문관리
export const URL_INITIAL_PRODUCT_ORDER_DETAIL1 = '/order/detail1'; // 교재 주문관리 상세1
export const URL_INITIAL_PRODUCT_ORDER_DETAIL2 = '/order/detail2'; // 교재 주문관리 상세2
export const URL_INITIAL_PRODUCT_ORDER_FIRST = '/order-first'; // 1차 초도물품 품목관리
export const URL_INITIAL_PRODUCT_ORDER_FIRST_DETAIL1 = '/order-first/detail1'; // 1차 초도물품 품목관리 상세1
export const URL_INITIAL_PRODUCT_ORDER_FIRST_DETAIL2 = '/order-first/detail2'; // 1차 초도물품 품목관리 상세2
export const URL_INITIAL_PRODUCT_ORDER_SECOND = '/order-second'; // 2차 초도물품 품목관리
/**
 * 초도물품 관리
 * @returns
 */
const InitialProductRoute = ({ common }) => {
  return (
    <Routes>
      <Route path={URL_INITIAL_PRODUCT_ORDER} element={<InitialProductOrder common={common} />} />
    </Routes>
  );
};

export default InitialProductRoute;
